import { formatDate, DATE_FORMATS } from '@frontend/mwm-ui'
import classNames from 'classnames'

import type { IBasicUserInfo } from '../types'
import type { ReactElement } from 'react'
import type { IAssetOption } from '~/types/option'

import UserCard from '~/components/UserCard'
import { formatBuilder, isUserId } from '~/utils/builder'
import { capitalize } from '~/utils/string'

import './styles.scss'

interface Props {
  backgroundColor: 'black' | 'colored' | 'default'
  className?: string
  label?: string
  option: IAssetOption
  users?: IBasicUserInfo[]
}

const UserInfos = ({ backgroundColor, className, label, option, users }: Props): ReactElement | null => {
  /** Local state */

  const user = users?.find(({ user_id }) => user_id === option.updatedBy)

  const userName = isUserId(option.updatedBy) ? user?.name : formatBuilder(option.updatedBy)

  /** Render */

  return user ? (
    <UserCard
      backgroundColor={backgroundColor}
      className={classNames('asset-details-user-card', className)}
      hide="picture"
      label={label}
      labelPosition="top"
      name={capitalize(userName)}
      picture={user.picture}
      size="small"
      subInfo={formatDate(option.updatedAt, DATE_FORMATS.DEFAULT_WITH_HOURS)}
    />
  ) : null
}

export default UserInfos
